export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FACTURE_AMOUT_LOWER_THAN_ACOMPTES') === 0) {
      messages.push({
        message: 'validationFacture.acompteGreaterThanFacture',
      });
    }
    if (message.indexOf('DATE_RENOUVELLEMENT_REQUIRED_IF_RENEWABLE') === 0) {
      messages.push({
        message: 'validationFacture.dateRenouvellementObligatoire',
      });
    }
    if (message.indexOf('DATE_PREAVIS_REQUIRED_IF_RENEWABLE') === 0) {
      messages.push({
        message: 'validationFacture.datePreavisObligatoire',
      });
    }
    if (message.indexOf('DATE_RENOUVELLEMENT_FORBIDDEN_WITHOUT_RENOUVELABLE') === 0) {
      messages.push({
        message: 'validationFacture.dateRenouvellementForbiddenWithoutRenouvelable',
      });
    }
    if (message.indexOf('DATE_PREAVIS_FORBIDDEN_WITHOUT_RENOUVELABLE') === 0) {
      messages.push({
        message: 'validationFacture.datePreavisForbiddenWithoutRenouvelable',
      });
    }
    if (message.indexOf('RENOUVELABLE_REQUIRED_IF_RECONDUCTIBLE') === 0) {
      messages.push({
        message: 'validationFacture.renouvellableRequiredIfReconductible',
      });
    }
    if (message.indexOf('TAUX_TVA_SHOULD_BE_ZERO_WITH_ANNONCEUR_WITH_EXONERATION_TVA') === 0) {
      messages.push({
        message: 'validationFacture.ligneCommandeWithZeroTva',
      });
    }
    if (message.indexOf('PERIODE_INVALIDE') === 0) {
      messages.push({
        message: 'validationFacture.periodeInvalide',
      });
    }
    if (message.indexOf('UNIT_PRICE_LESS_ZERO') === 0) {
      messages.push({
        message: 'facturation.messages.error.unitPriceLessZero',
      });
    }
    if (message.indexOf('ORDER_SAME_PAYER_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.samePayer',
      });
    }
    if (message.indexOf('COMMAND_LINE_ALREADY_BILL') === 0) {
      messages.push({
        message: 'facturation.messages.error.echeanceAlreadyBill',
      });
    }
    if (message.indexOf('ORDER_SAME_AGENCY_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.sameAgence',
      });
    }
    if (message.indexOf('ORDER_NO_DISCOUNT_LINE_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.noRemise',
      });
    }
    if (message.indexOf('ORDER_MANY_PAYER_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.noMultiPayerInCommande',
      });
    }
    if (message.indexOf('ORDER_MANY_ROLE_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.noMultiRoleInCommande',
      });
    }
    if (message.indexOf('DATES_OVERLAP') === 0) {
      messages.push({
        message: 'facturation.messages.error.dateOverlap',
      });
    }
    if (message.indexOf('ORDER_MANY_REPRESENTATIVE_IF_ONE_INVOICE_FOR_MANY_ORDER') === 0) {
      messages.push({
        message: 'facturation.messages.error.noMultiRepresentativeInCommande',
      });
    }
    if (message.indexOf('PROSPECT_NOT_ALLOWED') === 0) {
      messages.push({
        message: 'facturation.messages.error.prospectNotAllowed',
      });
    }
    if (message.indexOf('FACTURE_AMOUNT_LOWER_THAN_ACOMPTES') === 0) {
      messages.push({
        message: 'facturation.messages.error.factureAmountLowerThanAcomptes',
      });
    }
    if (message.indexOf('COMMAND_LINE_SHOULD_BE_BILLABLE') === 0) {
      const existeDejaMessage = !messages.some(m => {
        return m.message === 'facturation.messages.error.lineNotBillable';
      });
      if (existeDejaMessage) {
        messages.push({
          message: 'facturation.messages.error.lineNotBillable',
        });
      }
    }
    if (message.indexOf('BILL_ORDER_CLIENT_LOCKED') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: 'facturation.messages.error.lockedClient',
        parametres: { nomCommercial: params[1], code: params[2] },
      });
    }
    if (message.indexOf('INVOICE_FINANCIAL_COMMITMENT_DATE_INVALID') === 0) {
      const elements = message.split('|')[0].split('@');
      const payeur = elements[1];
      messages.push({
        message: 'validationFacture.invoiceFinancialCommitmentDateInvalid',
        parametres: {
          nomCommercial: payeur,
        },
      });
    }
    if (message.indexOf('INVOICE_FINANCIAL_COMMITMENT_COUNT_INVALID') === 0) {
      const elements = message.split('|')[0].split('@');
      const payeur = elements[1];
      messages.push({
        message: 'validationFacture.invoiceFinancialCommitmentCountInvalid',
        parametres: {
          nomCommercial: payeur,
        },
      });
    }
    if (message.indexOf('DRAFT_PURCHASE_ORDER_BROUILLON') === 0) {
      messages.push({ message: 'facturation.messages.error.draftPurchaseOrdreBrouillon' });
    }
    if (message.indexOf('PROXY_NOT_REPRESENTATIVE') === 0) {
      messages.push({
        message: 'validationFacture.proxyNotRepresentative',
      });
    }
    if (message.indexOf('START_DATE_GREATER_THAN_END_DATE') === 0) {
      messages.push({
        message: 'validation.dateDebutGreaterDateFin',
      });
    }
    if (message.indexOf('ECHEANCIERMERGE_VENTEINTERNE') === 0) {
      messages.push({
        message: 'facturation.messages.error.fusionEcheancierVenteInterne',
      });
    }
    if (message.indexOf('FACTURE_ECHLIGNE_MONTANT_NEGATIF') === 0) {
      messages.push({
        message: 'facturation.messages.error.echeanceMontantNegatif',
      });
    }
    if (message.indexOf('NORMAL_BILL_AMOUNT_POSITIVE') === 0) {
      messages.push({
        message: 'facturation.messages.error.normalBillAmountPositive',
      });
    }
  });
}
